import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getActiveLanguage } from 'react-localize-redux';

import './privacypolicy.scss';
import PrivacyPolicyHtmlIt from './../../translations/shared/privacy_policy/privacy_policy_it.html';
import PrivacyPolicyHtmlEn from './../../translations/shared/privacy_policy/privacy_policy_en.html';

class PrivacyPolicy extends React.Component {

  constructor(props) {
    super(props);

    this.selectPrivacyHtmlContent = this.selectPrivacyHtmlContent.bind(this);
  }

  /* Methods */
  selectPrivacyHtmlContent() {
    switch (this.props.match.params.lang || this.props.currentLanguage) {
      case 'it':
        return PrivacyPolicyHtmlIt;
      case 'en':
        return PrivacyPolicyHtmlEn;
      default:
        return PrivacyPolicyHtmlEn;
    }
  }

  /* Lifecycle */
  render() {
    return (
      <Grid className="privacypolicy-component">
        <Row>
          <Col xs={8} xsOffset={2}>
            <div dangerouslySetInnerHTML={{__html: this.selectPrivacyHtmlContent()}}/>
            <br/>
          </Col>
        </Row>
      </Grid>
    );
  }
}

PrivacyPolicy.displayName = 'PagesPrivacyPolicy';
PrivacyPolicy.propTypes = {};
PrivacyPolicy.defaultProps = {};

const mapStateToProps = (state) => {
  return {
    currentLanguage: getActiveLanguage(state.locale).code
  };
};

export default connect(mapStateToProps)(PrivacyPolicy);



// WEBPACK FOOTER //
// ./components/pages/PrivacyPolicy.js